// import _ from 'lodash';
import { cleanCartItemWithBackOrder } from '../selectors/converterSelectors'
import { isNewArrivalRequest } from '../../main/selectors/defaultSelectors'

const productsSupplier = {
  isLoading: false,
  list: {},
  userInput: {},

  active: '',
  activePage: 1,
  perPage: 60,
  totalPages: null,
  sortBy: typeof isNewArrivalRequest !== 'undefined' && isNewArrivalRequest() ? 'EnTimeCreated' : 'SortableTitle',
  sortDirection: typeof isNewArrivalRequest !== 'undefined' && isNewArrivalRequest() ? 'DESC' : 'ASC',
  tableView: 'grid',
  displayedList: [],
  filters: {},
  hasActiveFilters: false,
  searchKeyword: '',
  history: [],
  WithSuperSupplierBrands: false,
  SoldToThreePLOnly: false,
  FilterSoldAtLocation: false,
  WithDummyProducts: false,
}
const ProductsSupplierReducer = function (state = productsSupplier, action) {
  switch (action.type) {
    case 'TOGGLE_PRODUCT_LIST_SUPPLIER_LOADING': {
      return {
        ...state,
        isLoading: action.value,
      }
    }
    case 'SET_PRODUCTS_SUPPLIER_DISPLAYED_LIST': {
      return {
        ...state,
        displayedList: action.list,
      }
    }
    case 'SET_PRODUCTS_SUPPLIER_ACTIVE_PAGE': {
      return {
        ...state,
        activePage: action.value,
      }
    }
    case 'SET_PRODUCTS_SUPPLIER_PER_PAGE': {
      return {
        ...state,
        perPage: action.value,
      }
    }
    case 'SET_PRODUCTS_SUPPLIER_TOTAL_PAGES': {
      return {
        ...state,
        totalPages: action.value,
      }
    }
    case 'SET_PRODUCTS_SUPPLIER_SORT_BY': {
      return {
        ...state,
        sortBy: action.sortBy,
        sortDirection: action.sortDirection,
      }
    }
    case 'UPDATE_PRODUCTS_SUPPLIER_SEARCH': {
      return {
        ...state,
        searchKeyword: action.value,
      }
    }

    case 'UPDATE_SOLD_TO_THREE_PL_ONLY': {
      return {
        ...state,
        SoldToThreePLOnly: action.value,
      }
    }

    case 'UPDATE_SOLD_AT_LOCATION': {
      return {
        ...state,
        FilterSoldAtLocation: action.value,
      }
    }

    case 'UPDATE_WITH_SUPER_SUPPLIER_BRANDS': {
      return {
        ...state,
        WithSuperSupplierBrands: action.value,
      }
    }

    case 'UPDATE_WITH_DUMMY_PRODUCTS': {
      return {
        ...state,
        WithDummyProducts: action.value,
      }
    }

    case 'UPDATE_PRODUCTS_LIST_SUPPLIER': {
      let newList = {}

      Object.entries(action.list).forEach(([key, value]) => {
        newList[key] = { ...state.list[key], ...value }
      })

      return {
        ...state,
        list: {
          ...state.list,
          ...newList,
        },
      }
    }
    case 'UPDATE_PRODUCT_SUPPLIER_USER_INPUT': {
      const {
        frontline_case_price,
        qty_per_case,
        soh,
        calculatedSOH,
        id,
        case_price,
        unit_price,
        wetTax,
        case_discount,
        discounted_unit_price,
        discounted_case_price,
      } = action.row

      //Set default values to 0.00 in case of NaN
      let discountVal = ((case_discount / frontline_case_price) * 100).toFixed(2)
      let newUserInputRecord =
        typeof state.userInput[action.row.id] != 'undefined'
          ? { ...state.userInput[id] }
          : {
              calculatedSOH: calculatedSOH,
              // casePriceValue: (case_price - case_discount * (1 + wetTax)).toFixed(2),
              casePriceValue: discounted_case_price.toFixed(2) || '0.00',
              caseQty: 0,
              productID: id,
              qty_per_case: qty_per_case,
              soh: soh,
              // unitPriceValue: unit_price.toFixed(2),
              unitPriceValue: discounted_unit_price.toFixed(2) || '0.00',
              unitQty: 0,
              flatDiscountValue: case_discount.toFixed(2) || '0.00',
              // percentageDiscountValue: ((case_discount / case_price) * 100).toFixed(2),
              percentageDiscountValue: isNaN(discountVal) ? '0.00' : discountVal,
            }
      newUserInputRecord[action.key] = action.value

      let newUserInput = {
        ...state.userInput,
        [id]: newUserInputRecord,
      }

      // Now restructure them
      // @TODO: Handle the input fields properly
      newUserInput[id] = cleanCartItemWithBackOrder(newUserInput[id], state.list[id], 'product')

      return {
        ...state,
        userInput: newUserInput,
      }
    }
    case 'BATCH_UPDATE_PRODUCT_SUPPLIER_USER_INPUT': {
      let newUserInput = {
        ...state.userInput,
      }

      Object.entries(action.value).map(([id, modifiedData]) => {
        newUserInput[id] = {
          ...newUserInput[id],
          ...modifiedData,
        }
      })

      return {
        ...state,
        userInput: newUserInput,
      }
    }
    case 'UPDATE_PRODUCT_SUPPLIER_CASE_DISCOUNT': {
      const { qty_per_case, soh, id, case_price } = action.row

      let newUserInput = {
        ...state.userInput,
      }

      if (action.value === false) {
        delete newUserInput[id]
      } else {
        let newUserInputRecord =
          typeof state.userInput[action.row.id] != 'undefined'
            ? { ...state.userInput[id] }
            : {
                productID: id,
                soh: soh,
                qty_per_case: qty_per_case,
                unitQty: 0,
                caseQty: 0,
                casePriceValue: case_price,
              }

        newUserInputRecord = {
          ...newUserInputRecord,
          ...action.value,
        }

        newUserInput = {
          ...state.userInput,
          [id]: newUserInputRecord,
        }

        // Now restructure them
        // @TODO: Handle the input fields properly
        newUserInput[id] = cleanCartItemWithBackOrder(newUserInput[id], state.list[id], 'product')
      }

      return {
        ...state,
        userInput: newUserInput,
      }
    }
    case 'CLEAR_PRODUCT_SUPPLIER_USER_INPUT': {
      let newUserInput = { ...state.userInput }

      if (typeof newUserInput[action.id] != 'undefined') {
        newUserInput[action.id] = {
          ...newUserInput[action.id],
          caseQty: 0,
          unitQty: 0,
          caseBackOrder: 0,
          unitBackOrder: 0,
          caseTotal: 0,
          unitTotal: 0,
          cartQty: 0,
          backOrderQty: 0,
        }
      }

      return {
        ...state,
        userInput: newUserInput,
      }
    }
    case 'CLEAR_ALL_PRODUCT_SUPPLIER_USER_INPUT': {
      let newUserInput = { ...state.userInput }

      Object.entries(newUserInput).map(([key, value]) => {
        newUserInput[key] = {
          ...newUserInput[key],
          caseQty: 0,
          unitQty: 0,
          caseBackOrder: 0,
          unitBackOrder: 0,
          caseTotal: 0,
          unitTotal: 0,
          cartQty: 0,
          backOrderQty: 0,
        }
      })

      return {
        ...state,
        userInput: newUserInput,
      }
    }
    default: {
      return state
    }
  }
}

export default ProductsSupplierReducer
